module.exports = __webpack_public_path__ + "img/text-icon.adc0ae4e.png";